export const EASE = [0.16, 1, 0.3, 1];

export const VIEW_ONCE = { once: true, margin: "-80px" };
export const VIEW_NEAR = { once: true, margin: "-60px" };
export const VIEW_TIGHT = { once: true, margin: "-40px" };

export const reveal = {
  hidden: { y: 60, opacity: 0 },
  show: { y: 0, opacity: 1, transition: { duration: 1, ease: EASE } },
};

// Variant-level transitions win over the `transition` prop, so staggered
// children use this dynamic variant with custom={delayInSeconds}.
export const revealStaggered = {
  hidden: { y: 60, opacity: 0 },
  show: (delay = 0) => ({
    y: 0,
    opacity: 1,
    transition: { duration: 1, ease: EASE, delay },
  }),
};

export const lineReveal = {
  hidden: { y: "115%" },
  show: { y: "0%", transition: { duration: 1.1, ease: EASE } },
};

export const container = {
  hidden: {},
  show: { transition: { staggerChildren: 0.14, delayChildren: 0.25 } },
};

export const PAGE_INITIAL = { opacity: 0, y: 30 };
export const PAGE_ANIMATE = { opacity: 1, y: 0 };
export const PAGE_TRANSITION = { duration: 0.9, ease: EASE };
